import PropTypes from 'prop-types';
import React from 'react';

import Link from 'components/Link';

import VideoListItemImage from '../VideoListItemImage';

function VideoListItem(props) {
  const {
    imageAltText,
    imagePreviewURL,
    imageURL,
    videoURL,
    videoDuration,
    videoTitle,
  } = props;

  return (
    <div className="ontheshow__video-list-item">
      <Link to={videoURL}>
        <VideoListItemImage
          altText={imageAltText}
          url={imageURL}
          previewURL={imagePreviewURL}
        />
      </Link>
      <div>
        <div className="ontheshow__video-list-item-title">
          <a href={videoURL} className="ontheshow__video-list-item-link">{videoTitle}</a>
        </div>
        <div className="ontheshow__video-list-item-timestamp">
          {videoDuration}
        </div>
      </div>
    </div>
  );
}

VideoListItem.propTypes = {
  imageAltText: PropTypes.string,
  imagePreviewURL: PropTypes.string,
  imageURL: PropTypes.string,
  videoDuration: PropTypes.string,
  videoTitle: PropTypes.string,
  videoURL: PropTypes.string,
};

VideoListItem.defaultProps = {
  imageAltText: undefined,
  imagePreviewURL: undefined,
  imageURL: undefined,
  videoDuration: undefined,
  videoTitle: undefined,
  videoURL: undefined,
};

export default VideoListItem;
